import { fetchVerificarDuplicidade } from 'store/fetchActions/fetchFormulario';
import { fetchNotificationApp } from 'store/fetchActions/fetchApp';
import { removeTodasMascaras } from 'utils/stringFormatter';
import { calcularMb, converterByteToMb } from 'utils/arquivo';
import { generateId } from 'utils/funcaoPadrao';
import { convertDatePtBrHs } from 'utils/dateFormatter';
import { ALERTA, ALERTA_REPETICAO, REQUERIMENTO_DUPLICADO } from 'utils/consts';
import { VLibrasIsOpen } from 'utils/acessibilidade';

export const verificarDuplicidade = (documento, dados) => dispatch => {
  const documentoEnviar = documento || dados?.cpf || dados?.cnpj;
  if (dados?.servico && documentoEnviar) {
    dispatch(fetchVerificarDuplicidade(dados?.servico, removeTodasMascaras(documentoEnviar))).then(retorno => {
      if (retorno?.id !== 0) {
        const data = new Date(retorno?.dataAbertura);
        const hora = data?.getHours()?.toString()?.padStart(2, '0');
        const minuto = data?.getMinutes()?.toString()?.padStart(2, '0');
        const segundos = data?.getSeconds()?.toString()?.padStart(2, '0');
        const mensagem = REQUERIMENTO_DUPLICADO(`${hora}:${minuto}:${segundos}`);
        fetchNotificationApp(ALERTA_REPETICAO, mensagem, ALERTA.AVISO, 'bottomRight', 10);
        return mensagem;
      }
    });
  }
  return null;
};

export const montarServicosUrl = (todosServicos, servicosExibir, servicoDefault) => {
  const retorno = { listaExibir: null, itemSelecionado: null };
  let listaIdExibir = [];
  const servicoSelecionado = Number(servicoDefault);

  if (servicosExibir) {
    listaIdExibir = servicosExibir.split(',').map(Number);

    if (!listaIdExibir.includes(servicoSelecionado)) {
      listaIdExibir.push(servicoSelecionado);
    }
  }

  if (listaIdExibir.length > 0) {
    retorno.listaExibir = todosServicos.filter(x => listaIdExibir.includes(x.id));
  } else {
    retorno.listaExibir = todosServicos;
  }

  if (servicoSelecionado) {
    retorno.itemSelecionado = todosServicos.filter(s => s.id === servicoSelecionado)[0];
  }

  return retorno;
};

export const formataArquivoGrid = arquivo => {
  const key = generateId();
  const data = convertDatePtBrHs(new Date())?.toString();
  return {
    key: arquivo?.key || key,
    nomeArquivo: arquivo.name,
    tamanhoArquivo: converterByteToMb(arquivo.size),
    data: data,
  };
};

const addTotalizador = (dataGrid, setDataGrid, tamanhoTotal) => {
  if (VLibrasIsOpen()) {
    const totalizador = {
      key: `TOTALIZADOR_TEMP_${generateId()}`,
      nomeArquivo: 'Tamanho total:',
      tamanhoArquivo: `${tamanhoTotal} / 10`,
      data: '-',
    };
    setDataGrid([...dataGrid.filter(x => x.key.startsWith('TOTALIZADOR_TEMP') !== true), totalizador]);
  } else {
    setDataGrid(dataGrid);
  }
};

export const handleAddItemGrid = (
  file,
  dadosGrid,
  arquivosAdicionados,
  setArquivosAdicionados,
  setDadosGrid,
  setTamanhoTotalArquivos,
  salvarAquivos
) => {
  const { isValid, soma } = calcularMb(file.size, dadosGrid, 10);
  const retorno = { isValid, soma, item: null };

  if (isValid) {
    //MONTAR OBJETOS PARA SALVAR
    const arquivo = file;
    const itemFormatado = formataArquivoGrid(arquivo);
    retorno.item = itemFormatado;
    setArquivosAdicionados([...arquivosAdicionados, arquivo]);
    addTotalizador([...dadosGrid, itemFormatado], setDadosGrid, `${soma.toFixed(2)}`);
    setTamanhoTotalArquivos(`${soma.toFixed(2)} MB`);
    salvarAquivos({ arquivos: [...arquivosAdicionados, arquivo], arquivosGrid: [...dadosGrid, itemFormatado] });
  }
  return retorno;
};

export const handleRemoverItemGrid = (
  itensSelecionados = [],
  dadosGrid,
  arquivosAdicionados,
  setDadosGrid,
  setArquivosAdicionados,
  salvarAquivos,
  setTamanhoTotalArquivos
) => {
  const getListaNomeSelecionados = itensSelecionados.map(selecioado => selecioado.nomeArquivo);
  //REMOVE ITENS DA GRID
  const listaFiltrada = dadosGrid.filter(objeto => itensSelecionados.indexOf(objeto) === -1);
  //REMOVE ARQUIVOS SALVOS
  const arquivosManter = arquivosAdicionados.filter(arquivo => !getListaNomeSelecionados.includes(arquivo.name));

  //CALCULA VALOR TOTAL MB
  const { soma } = calcularMb(0, listaFiltrada, 10);
  //SALVA ESSAS NOVAS LISTAS
  setDadosGrid(listaFiltrada);
  setArquivosAdicionados(arquivosManter);
  salvarAquivos({ arquivos: arquivosManter, arquivosGrid: listaFiltrada });
  setTamanhoTotalArquivos(`${soma.toFixed(2)} MB`);
  return { grid: listaFiltrada, arquivos: arquivosManter, soma };
};
